document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".coverflow-stage").forEach(initCoverflow);
});

function initCoverflow(stage) {
  const track = stage.querySelector(".coverflow-track");
  const items = Array.from(track.querySelectorAll(".coverflow-item"));
  const n = items.length;
  if (n === 0) return;

  const CONFIG = {
    spacing: 190,
    maxVisible: parseFloat(stage.dataset.maxVisible) || 3,
    scaleStep: parseFloat(stage.dataset.scaleStep) || 0.16,
    rotateStep: parseFloat(stage.dataset.rotateStep) || 18,
    depthStep: 120,
    dragSensitivity: parseFloat(stage.dataset.dragSensitivity) || 0.9,
    snapEase: parseFloat(stage.dataset.snapEase) || 380,
    autoplayDelay: parseFloat(stage.dataset.autoplayDelay) || 0,
    spacingMultiplier: parseFloat(stage.dataset.spacingMultiplier) || 1.15,
  };

  const baseMaxVisible = parseFloat(stage.dataset.maxVisible) || 3;

  // Spread images to fill the available width, instead of a fixed px gap.
  function computeSpacing() {
    const w = stage.clientWidth || stage.parentElement.clientWidth;
    const slots = CONFIG.maxVisible * 2 + 1.4;
    const mobileBoost = window.innerWidth < 480 ? 1.35 : 1;
    return (w / slots) * CONFIG.spacingMultiplier * mobileBoost;
  }

  function updateResponsiveConfig() {
    // Fewer visible neighbors on narrow screens so items don't overlap/cram together.
    CONFIG.maxVisible = window.innerWidth < 480
      ? 1
      : window.innerWidth < 720
        ? Math.min(baseMaxVisible, 2)
        : baseMaxVisible;
    CONFIG.spacing = computeSpacing();
  }
  updateResponsiveConfig();
  window.addEventListener("resize", () => {
    updateResponsiveConfig();
    render();
  });

  let current = 0;
  let isDragging = false;
  let dragStartX = 0;
  let dragStartIndex = 0;
  let autoplayTimer = null;

  function mod(a, m) { return ((a % m) + m) % m; }

  function circularOffset(i, cur) {
    let raw = i - cur;
    raw = ((raw % n) + n) % n;
    if (raw > n / 2) raw -= n;
    return raw;
  }

  items.forEach((el, i) => {
    el.addEventListener("click", () => {
      if (isDragging) return;
      if (Math.abs(circularOffset(i, current)) < 0.05) return;
      goTo(i);
    });
  });

  function render() {
    items.forEach((el, i) => {
      const offset = circularOffset(i, current);
      const abs = Math.abs(offset);

      if (abs > CONFIG.maxVisible + 0.6) {
        el.style.opacity = "0";
        el.style.pointerEvents = "none";
        return;
      }

      const scale = Math.max(1 - abs * CONFIG.scaleStep, 0.25);
      const rotateY = offset * -CONFIG.rotateStep;
      const translateX = offset * CONFIG.spacing;
      const translateZ = -abs * CONFIG.depthStep;
      const z = Math.round(100 - abs * 10);

      el.style.transform =
        `translate(-50%, -50%) translateX(${translateX}px) translateZ(${translateZ}px) rotateY(${rotateY}deg) scale(${scale})`;
      el.style.opacity = "1";
      el.style.zIndex = String(z);
      el.style.pointerEvents = "auto";
      el.classList.toggle("is-center", abs < 0.05);
    });
  }

  function animateTo(target, withEase) {
    const start = current;
    let delta = target - start;
    if (delta > n / 2) delta -= n;
    if (delta < -n / 2) delta += n;
    const startTime = performance.now();
    const duration = withEase ? CONFIG.snapEase : 0;

    if (duration === 0) {
      current = mod(target, n);
      render();
      return;
    }

    function step(now) {
      const t = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      current = mod(start + delta * eased, n);
      render();
      if (t < 1) requestAnimationFrame(step);
      else current = mod(target, n);
    }
    requestAnimationFrame(step);
  }

  function goTo(index) {
    stopAutoplay();
    animateTo(index, true);
    scheduleAutoplay();
  }

  function pointerX(e) {
    return e.touches ? e.touches[0].clientX : e.clientX;
  }

  function onPointerDown(e) {
    stopAutoplay();
    isDragging = true;
    stage.classList.add("dragging");
    dragStartX = pointerX(e);
    dragStartIndex = current;
    window.addEventListener("mousemove", onPointerMove);
    window.addEventListener("mouseup", onPointerUp);
    window.addEventListener("touchmove", onPointerMove, { passive: true });
    window.addEventListener("touchend", onPointerUp);
  }

  function onPointerMove(e) {
    if (!isDragging) return;
    const dx = pointerX(e) - dragStartX;
    const deltaIndex = (dx / CONFIG.spacing) * CONFIG.dragSensitivity;
    current = mod(dragStartIndex - deltaIndex, n);
    render();
  }

  function onPointerUp() {
    if (!isDragging) return;
    isDragging = false;
    stage.classList.remove("dragging");
    window.removeEventListener("mousemove", onPointerMove);
    window.removeEventListener("mouseup", onPointerUp);
    window.removeEventListener("touchmove", onPointerMove);
    window.removeEventListener("touchend", onPointerUp);
    animateTo(Math.round(current), true);
    scheduleAutoplay();
  }

  stage.addEventListener("mousedown", onPointerDown);
  stage.addEventListener("touchstart", onPointerDown, { passive: true });

  stage.addEventListener("keydown", (e) => {
    if (e.key === "ArrowRight") goTo(mod(Math.round(current) + 1, n));
    if (e.key === "ArrowLeft") goTo(mod(Math.round(current) - 1, n));
  });

  function scheduleAutoplay() {
    if (!CONFIG.autoplayDelay) return;
    stopAutoplay();
    autoplayTimer = setTimeout(() => {
      animateTo(mod(Math.round(current) + 1, n), true);
      scheduleAutoplay();
    }, CONFIG.autoplayDelay);
  }
  function stopAutoplay() {
    if (autoplayTimer) clearTimeout(autoplayTimer);
  }

  render();
  scheduleAutoplay();
}
